module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_odiya.2b2e67c9.mp3";